export const selectStyles = {
  root: 'flex w-full flex-col gap-1.5',
  label: 'font-sans text-sm font-medium text-brand-950',
  field:
    'w-full min-h-11 appearance-none rounded-md border border-brand-700/35 bg-surface px-3 py-2.5 pr-8 font-sans text-md text-brand-950 transition-colors focus:border-brand-400 focus:outline-none focus:ring-2 focus:ring-brand-400 md:min-h-10 md:py-2 md:text-sm',
  fieldError: 'border-red-500 focus:border-red-500 focus:ring-red-500',
  error: 'text-sm text-red-600',
} as const;
